import {
    MatDialogActions,
    MatDialogContent,
    MAT_DIALOG_DATA,
    MatDialogTitle,
    MatDialogRef,
    MatDialog,
} from '@angular/material/dialog';
import {FormArray, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {DeleteConfirmDialogComponent, Kalender, KalenderService as KalenderApiService} from 'kkm-library';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {NotificationService} from 'kkm-library';
import {Component, inject} from '@angular/core';
import {lastValueFrom} from 'rxjs';

import {KalenderService} from '../kalender.service';

@Component({
    selector: 'kkm-kalender-form-dialog',
    imports: [
        MatDialogTitle,
        MatDialogContent,
        MatDialogActions,
        MatButtonModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatCheckboxModule,
    ],
    templateUrl: './kalender-form-dialog.component.html',
    styleUrl: './kalender-form-dialog.component.scss',
})
export class KalenderFormDialogComponent {
    public dialogRef = inject(MatDialogRef<KalenderFormDialogComponent>);
    private notification = inject(NotificationService);
    private kalenderApiService = inject(KalenderApiService);
    private kalenderService = inject(KalenderService);
    public dialog = inject(MatDialog);

    public data = inject<{kalender: Kalender}>(MAT_DIALOG_DATA);

    constructor() {
        if (this.data.kalender) {
            this.kalender = this.data.kalender;
        } else {
            this.kalender = this.kalenderService.newKalender();
        }

        this.rights.removeAt(-1);
        this.rights.clear();
        this.kalender.rights?.forEach(() => {
            this.rights.push(this.newRightForm());
        });
        this.kalenderForm.patchValue(this.kalender);
    }

    kalender: Kalender = this.kalenderService.newKalender();

    kalenderForm = new FormGroup({
        id: new FormControl<number>(0, {nonNullable: true}),
        titel: new FormControl('', {nonNullable: true, validators: [Validators.required]}),
        farbe: new FormControl('#000000', {nonNullable: true}),
        oeffentlich: new FormControl(false, {nonNullable: true}),

        rights: new FormArray([this.newRightForm()]),
    });

    get rights() {
        return this.kalenderForm.controls['rights'] as FormArray;
    }

    newRightForm(): FormGroup {
        return new FormGroup({
            group: new FormControl<string>('', {nonNullable: true}),
            read: new FormControl(false, {nonNullable: true}),
            write: new FormControl(false, {nonNullable: true}),
        });
    }

    speichern(): void {
        if (!this.kalenderForm.valid) {
            this.notification.error('Es sind nicht alle Felder ausgefüllt');
            return;
        }

        const newKalender = Object.assign(this.kalenderService.newKalender(), this.kalenderForm.value);
        const handleResponse = (response: Kalender) => {
            if (response.id) {
                this.notification.success('Gespeichert');
                this.dialogRef.close(true);
            }
        };

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const handleError = (error: any) => {
            this.notification.error(`Beim Speichern ist ein Fehler aufgetreten. ${error.error.message}`);
        };

        if (!newKalender.id) {
            lastValueFrom(this.kalenderApiService.newKalender(newKalender)).then(handleResponse, handleError);
        }

        if (newKalender.id) {
            lastValueFrom(this.kalenderApiService.editKalender(newKalender.id, newKalender)).then(
                handleResponse,
                handleError,
            );
        }
    }

    /** Dialog schließen */
    onCancel(): void {
        this.dialogRef.close(false);
    }

    /** Dialog schließen */
    delete(): void {
        this.dialog
            .open(DeleteConfirmDialogComponent)
            .afterClosed()
            .subscribe(result => {
                if (result && this.kalender.id) {
                    lastValueFrom(this.kalenderApiService.deleteKalender(this.kalender.id)).then(() => {
                        this.notification.success('Gespeichert');
                        this.dialogRef.close(true);
                    });
                }
            });
    }
}
